import IMG_STORE_APPLE_KO from '~/assets/images/stores/store-apple.ko.png';
import IMG_STORE_APPLE_EN from '~/assets/images/stores/store-apple.en.png';
import IMG_STORE_APPLE_JA from '~/assets/images/stores/store-apple.ja.png';
import IMG_STORE_GOOGLE_KO from '~/assets/images/stores/store-google.ko.png';
import IMG_STORE_GOOGLE_EN from '~/assets/images/stores/store-google.en.png';
import IMG_STORE_GOOGLE_JA from '~/assets/images/stores/store-google.ja.png';
import IMG_STORE_GALAXY_KO from '~/assets/images/stores/store-galaxy.ko.png';
import IMG_STORE_GALAXY_EN from '~/assets/images/stores/store-galaxy.en.png';
import IMG_STORE_GALAXY_JA from '~/assets/images/stores/store-galaxy.ja.png';
import IMG_STORE_ONE_KO from '~/assets/images/stores/store-one.ko.png';
import IMG_STORE_ONE_EN from '~/assets/images/stores/store-one.en.png';

import { useFrontmatter } from '~/shared/contexts/frontmatter';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { css } from '~/css';

type StoreKey = 'apple' | 'google' | 'galaxy' | 'one';
interface StoreData {
  url: string;
  images: Record<string, string>;
}

const STORES: Record<StoreKey, StoreData> = {
  apple: {
    url: 'https://apps.apple.com/app/:id',
    images: {
      ko: IMG_STORE_APPLE_KO,
      en: IMG_STORE_APPLE_EN,
      ja: IMG_STORE_APPLE_JA,
    },
  },
  google: {
    url: 'https://play.google.com/store/apps/details',
    images: {
      ko: IMG_STORE_GOOGLE_KO,
      en: IMG_STORE_GOOGLE_EN,
      ja: IMG_STORE_GOOGLE_JA,
    },
  },
  galaxy: {
    url: '## Not Use',
    images: {
      ko: IMG_STORE_GALAXY_KO,
      en: IMG_STORE_GALAXY_EN,
      ja: IMG_STORE_GALAXY_JA,
    },
  },
  one: {
    url: 'https://onesto.re/:id',
    images: {
      ko: IMG_STORE_ONE_KO,
      en: IMG_STORE_ONE_EN,
    },
  },
};

function StoreButtons() {
  const frontmatter = useFrontmatter();
  const stores = (
    [
      { type: 'apple', id: frontmatter.appleAppId },
      { type: 'google', id: frontmatter.googleAppId },
      { type: 'one', id: frontmatter.onestoreAppId },
      { type: 'galaxy', id: frontmatter.galaxystoreUrl },
    ] satisfies { type: StoreKey; id: string | undefined }[]
  ).filter(({ id }) => id);

  function getUrl(type: StoreKey, id: string) {
    if (/https?:\/\//.test(id)) {
      return id;
    }

    const url = new URL(STORES[type].url, 'https://example.com');
    if (url.pathname.includes(':id')) {
      url.pathname = url.pathname.replace(':id', id!);
    } else {
      url.searchParams.set('id', id!);
    }

    return url.toString();
  }

  return (
    <Wrapper>
      {stores.map(({ type, id }) => {
        const url = getUrl(type, id!);

        return (
          <a key={type} href={url} target='_blank' rel='noopener noreferrer'>
            <img src={STORES[type].images[frontmatter.locale]} alt={`${type} Store`} height={64} />
          </a>
        );
      })}
    </Wrapper>
  );
}

export default StoreButtons;

const Wrapper = styled.section(
  css({
    display: 'flex',
    gap: rem(10),
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100vw',
    flexWrap: 'wrap',
    '& a': {
      lineHeight: 0,
    },

    '& img': {
      height: [rem(44), rem(44), rem(64)],
    },
  }),
);
